/// <summary>
/// This object provides js functions for an advanced signal selection <br/>
/// It generates various signal infos and opens an vcMenu signal selection on click (vcVisual().showSignalSelectionPopup())
/// There are 3 different visuals:<br/>
/// Simple: shows simple signal selection
/// Full: shows signal with more signal information
/// Selectionbox: shows an optionbox with the signal information
/// <br/>
/// Author: AFU<br />
/// Date: 11.7.2024<br />
/// Copyright ©: EUDT GmbH 2024 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 11.7.2024                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.SignalSelectionSimple", jQuery.common.vcBaseV4, {
    myPopup: null,
    myTest: null,
    type: "simple",  //sub visual type
  
    _create: function () {
        this._createVisual(363); 
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".sa-selection");
            //add sub visual type
            me.myRoot.addClass(me.type);
            //store start parameters
            me.myStatus = me.specific.startParameter;
           
            me._buildHtml();
            me._fetch();
            return true;
        } catch (e) {
            me._writeErr(e);return false;
        }
    },

    _initEvents: function () { this._initStructure();},

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        var me = this;
        try {

            me.myHtml = {selection: {} };

            let obj = me.myHtml.selection;

            obj.wrapper = me._setWrapper("", "").removeClass("vc-grid-margin-bottom");
            obj.content = me._setObj("content", "");
            obj.entry = me._setObj("entry", "float-box").html(this.getLoadingIcon());
            obj.icon = $("<i>").addClass("fa fa-solid fa-down color-font-secondary");
            obj.content.append(obj.entry, obj.icon);
            obj.wrapper.append(obj.content);

            me.myRoot.append(obj.wrapper);

        } catch (e) {
            me._writeErr(e);
            return false;
        }
        return true;
    },


    _initStructure: function () {
        /// <summary>
        /// This function inits the click handler and the reponse trigger of the vcMenu
        /// </summary>
        var me = this;
        try {

              ////init selection popup
            me.myHtml.selection.wrapper.off("click").on("click", function () {
                if (me.myData == null) return true;
                //we generate an unique id
                me.myData.PopupId = parseInt(Math.random() * 100000, 10);
                myPopup = me.vcV.showSignalSelectionPopup({ LoggerId: me.settings.blid, PopupIdentifier: me.myData.PopupId, SelectedBsaids: [me.myStatus.Bsaid] });
                console.info(me.myStatus);
            });

            //trigger for vcMenu response
            $("body").on("Trigger-vcMenu-PopupSelection", function (e) {
             
                //we only use triggers with our unique id
                if (me.myData.PopupId == e.value.id) {
                    me.myStatus.newList = e.value.list;
                    myPopup.dialog('close');
                    if (me.myStatus.newList.length == 0) { return true; }
                    me.myStatus.Bsaid = me.myStatus.newList[0];
                    me._fetch();
                }
            });

        } catch (e) { me._writeErr(e); }
    },

    _fetch: function () {
        /// <summary>
        /// This function fetches the data based on the current setings
        /// </summary>
        var me = this;
        try {
           
            if (me.myStatus == null) { me._setErrorInfo();return false;}
            if (typeof me.myStatus.Bsaid == 'undefined') { me._setErrorInfo(); return false; }
            if (me.myStatus.Bsaid == null) { me._setErrorInfo(); return false; }

             var param = me.myStatus.Bsaid;

            me.getData(param, function (result) {
              
                if (result == null) { me._setErrorInfo(); me.myData = null; return true;}
                me.myData = result;
                if (me.myData == null) {
                    me.myHtml.selection.entry.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                    return false;
                }
                return me._generateEntry();
                
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    
    _setErrorInfo: function () {
        /// specific error for the entry html
        this.myHtml.selection.entry.html($("<div>").addClass("icon-color-error").html(this.resources.noEntriesExist));
    },




    _generateEntry: function () {
        /// <summary>
        /// This function generates the signal info
        /// </summary>
        var me = this;
        try {

            me.myHtml.selection.entry.html(me.myData.Info.Name + " [" + me.myData.Info.SignalUnit.Name + "]" );
            return true;

        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },


    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function handles error states - it hides specific objects on error message
        /// </summary>
        var me = this;
        try {
            if (bError) {
                me.myHtml.selection.wrapper.hide();
             
            }
            return true;
        } catch (e) {
            me._writeErr(e); return false;
        }
    }
});

jQuery.widget("bluaul.SignalSelectionFull", $.bluaul.SignalSelectionSimple, {

    type: "full",
    _generateEntry: function () {
        /// <summary>
        /// This function generates the signal info
        /// </summary>
        var me = this;
        try {

            //clear list
            var html = me.myData.Info.Name + " [" + me.myData.Info.SignalUnit.Name + "]";
            html += "<br/>";
            html += me.myData.Info.SignalGroup.Name + " / " + me.myData.Main.SignalType.Name;
            me.myHtml.selection.entry.html(html);


            return true;

        } catch (e) {
            me._writeErr(e);
            return false;
        }
    }
});

jQuery.widget("bluaul.SignalSelectionBox", $.bluaul.SignalSelectionSimple, {
    type: "selectionbox",
    myOptionBox: null,
    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {
            this._super();
            me.myHtml.selection.wrapper.html("");
            myOptionBox = me.myHtml.selection.wrapper.vcOptionBox({
              
                items: [
                    { button: me.specific.resources.signal, clickable: false, content: me.myHtml.selection.content },
                ], callback: function () { }
            });



        } catch (e) { me._writeErr(e); }
    },
    //_generateEntry: function () {
    //    /// <summary>
    //    /// This function generates the signal info
    //    /// </summary>
    //    var me = this;
    //    try {
    //        //me.myHtml.selection.entry.html(me.myData.Info.Name + " [" + me.myData.Info.SignalUnit.Name + "]");
    //    } catch (e) { me._writeErr(e);}
    //}
});